import { useEffect, useState } from 'react';
import { useAppSelector, useAppDispatch } from '../../../contexts/hooks';
import Popup from 'devextreme-react/popup';
import { setModalBarcodePrintersVisible } from '../../../contexts/slices/config';
import { useApiBarcodes } from '../../../api/api.barcodes';
import { List } from 'devextreme-react';
import { SysI_CodBarrasImpresoras } from '../../../types/types.barcodes';
import './ModalBarcodesPrinters.scss';
import { useScreenSize } from '../../../utils/media-query';
import { barcodePrintIcon } from '../../../images/icons';
import { newToast } from '../..';

const ModalBarcodesPrinters = () => {
  const dispatch = useAppDispatch();
  const ModalVisible = useAppSelector((state) => state.configuration.ModalBarcodePrintersVisible);
  const { getPrinters } = useApiBarcodes();
  const [printersData, setPrintersData] = useState<SysI_CodBarrasImpresoras[] | null | undefined>([]);
  const { isXSmall } = useScreenSize();
  // Cuando la modal es visible, obtenemos los datos de la API
  useEffect(() => {
    if (ModalVisible) {
      const fetchPrinters = async () => {
        const printers = await getPrinters();
        setPrintersData(printers);
      };
      fetchPrinters();
    }
  }, [ModalVisible]);

  // Método para manejar el cierre de la modal
  const handleClose = () => {
    dispatch(setModalBarcodePrintersVisible(false));
  };

  const handlePrinterSelect = (printer: SysI_CodBarrasImpresoras | undefined) => {
    if (printer) {
      // Guardar la impresora seleccionada en localStorage
      localStorage.setItem('defaultPrinter', JSON.stringify(printer));
      newToast('SUCCESS', `Se ha seleccionado la impresora '${printer.Cbp_Nombre}' como predeterminada`, 5);
      handleClose();
    }
  };

  // ItemRender personalizado para mostrar cada impresora con borde e icono
  const itemTemplate = (data: SysI_CodBarrasImpresoras) => {
    return (
      <div className='modal-item'>
        {/* Ícono de impresora de código de barras */}
        <img src={barcodePrintIcon} width={25} alt={data.Cbp_Nombre} className='modal-item-icon ' />
        <div>
          <div className='modal-item-text'>{data.Cbp_Nombre}</div>
          <div className='modal-item-description'>{data.Cbp_Descripcion || 'No description'}</div>
          <div className='modal-item-url'>{data.Cbp_Url}</div>
        </div>
      </div>
    );
  };

  return (
    <Popup visible={ModalVisible} onHiding={handleClose} fullScreen={isXSmall} showTitle title='Seleccionar Impresora' width={600} height={'auto'} showCloseButton>
      <h6 className='title-printer'>Se han detectado varias impresoras de códigos de barras. Por favor, seleccione la impresora predeterminada para este navegador.</h6>
      <List dataSource={printersData} itemRender={itemTemplate} onItemClick={(e) => handlePrinterSelect(e.itemData)} height={'auto'} />
    </Popup>
  );
};

export default ModalBarcodesPrinters;
